"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineParameterManager = void 0;
const v1_1 = require("./v1");
__exportStar(require("./v1"), exports);
/**
 * @param whitelistParams list of search parameter kes that is allowed to be stored
 */
const defineParameterManager = (whitelistParams) => ({
    id: 'parameter-manager',
    create: () => {
        const parameterManager = new v1_1.ParameterManagerV1(whitelistParams);
        return {
            '1.0.0': () => ({
                featureService: parameterManager,
            }),
        };
    },
});
exports.defineParameterManager = defineParameterManager;
//# sourceMappingURL=index.js.map